import { createAction } from '@wix/communities-blog-client-common';

export const OPEN_POST_PAGE_IN_EDITOR = 'bi/OPEN_POST_PAGE_IN_EDITOR';
export const biOpenPostPageInEditor = createAction(OPEN_POST_PAGE_IN_EDITOR);
